export const jituxDashboardAppId = "jitux-dashboard";
export const loginAppId = "login";
